import { useNavigate } from 'react-router-dom';
import { Badge, ConsolePage, DStat, EmptyState, Panel } from '@/components';
import { useCertificates, useCourses, useInvites, useUsers } from '@/hooks/queries';
import { professions } from '@/data/professions';
import { roleDefs } from '@/data/roleDefs';

export function AdminDashboard() {
  const navigate = useNavigate();
  const { data: invites = [] } = useInvites();
  const { data: users = [] } = useUsers();
  const { data: courses = [] } = useCourses();
  const { data: certs = [] } = useCertificates();

  const activeInvites = invites.filter((i) => i.status === 'active');
  const activeCourses = courses.filter((c) => c.status === 'active');

  return (
    <ConsolePage title="Dashboard" th="ภาพรวมระบบ" crumbs="OVERVIEW" maxWidth={1140}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(190px,1fr))', gap: 14 }}>
          <button onClick={() => navigate('/admin/users')} style={{ all: 'unset', cursor: 'pointer', display: 'block' }}>
            <DStat label="Staff" value={String(users.length)} icon="users" sub="registered accounts" />
          </button>
          <button onClick={() => navigate('/admin/invites')} style={{ all: 'unset', cursor: 'pointer', display: 'block' }}>
            <DStat label="Active invites" value={String(activeInvites.length)} icon="flag" tone="var(--spark)" sub="awaiting redemption" />
          </button>
          <button onClick={() => navigate('/admin/courses')} style={{ all: 'unset', cursor: 'pointer', display: 'block' }}>
            <DStat label="Active courses" value={String(activeCourses.length)} icon="book" sub={`${courses.length} total`} />
          </button>
          <button onClick={() => navigate('/admin/reports')} style={{ all: 'unset', cursor: 'pointer', display: 'block' }}>
            <DStat label="Certificates issued" value={String(certs.length)} icon="award" tone="var(--spark)" sub="to date" />
          </button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1.5fr) minmax(0,1fr)', gap: 18 }} className="max-md:!grid-cols-1">
          <Panel
            title="Analytics"
            action={<button className="btn btn-quiet btn-sm" onClick={() => navigate('/admin/reports')}>Reports</button>}
          >
            <EmptyState
              icon="chart"
              title="No analytics yet"
              hint="Completion, attendance and certificate trends will appear here as staff enrol and finish courses."
            />
          </Panel>

          <Panel title="Active invites" action={<button className="btn btn-quiet btn-sm" onClick={() => navigate('/admin/invites')}>Manage</button>} pad={false}>
            <div className="divide">
              {activeInvites.slice(0, 5).map((inv) => (
                <div key={inv.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '13px 18px' }}>
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontSize: 13.5, fontWeight: 500 }}>{roleDefs[inv.role].label.en} · {professions[inv.profession].label.en}</div>
                    <div className="muted" style={{ fontSize: 12 }}>{inv.dept} / {inv.unit}</div>
                  </div>
                  <Badge kind="sage" dot>{inv.uses}/{inv.maxUses}</Badge>
                </div>
              ))}
              {activeInvites.length === 0 && <div className="muted" style={{ padding: 24, textAlign: 'center', fontSize: 13 }}>No active invites.</div>}
            </div>
          </Panel>
        </div>
      </div>
    </ConsolePage>
  );
}
